import { Component, OnInit } from '@angular/core';
import { ValidationError, AuthorizeService, FormValidationService, AlertService, 
  ErrorHandlingService, TokenAuthResponseModel } from 'core-lib';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'cli-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(private authorizeSvc: AuthorizeService,
    private formValidationSvc: FormValidationService,
    private alertSvc: AlertService,
    private errorHandlingSvc: ErrorHandlingService,
    private router: Router) {
  }

  public defaultRoute = 'app/dashboard';
  public vm = new LoginViewModel();

  ngOnInit() {
  }

  public login(): void {

    if (!this.validate(this.vm)) { return; }

    this.vm.isLoading = true;

    this.authorizeSvc.isRememberMe = this.vm.isRememberMe;
    this.authorizeSvc.authorize(this.vm.userName, this.vm.password).toPromise().then(
      (r: TokenAuthResponseModel) => {

        if (r.code == 200 && this.authorizeSvc.accessToken && (this.authorizeSvc.userType === 'User')) {
          this.router.navigate([this.defaultRoute]);
          return;
        }

        this.handleLoginError();

      }, (e) => {
        
        this.handleLoginError();
        
      }).finally(()=>{
        this.vm.isLoading = false;
      });
  }

  private handleLoginError(): void {
    this.vm.errors = [];
    this.vm.errors.push(new ValidationError('userName', 'Invalid username/password'));
    this.vm.isLoading = false;
  }

  public error(fieldName: string): string {
    return this.formValidationSvc.getErrorMessage(this.vm, fieldName);
  }

  public validate(vm: LoginViewModel): boolean {
    vm.errors = [];

    if (!vm.userName || vm.userName.length === 0) {
      vm.errors.push(new ValidationError('userName', 'Login is required'));
    } else {
      if (vm.userName.length > 100) {
        vm.errors.push(new ValidationError('userName', 'Login cannot be more than 100 characters'));
      }
    }

    if (!vm.password || vm.password.length === 0) {
      vm.errors.push(new ValidationError('password', 'Password is required'));
    } else {
      if (vm.password.length < 6) {
        vm.errors.push(new ValidationError('password', 'Password cannot be less than 6 characters'));
      }
      if (vm.password.length > 50) {
        vm.errors.push(new ValidationError('password', 'Password cannot be more than 50 characters'));
      }
    }

    return vm.errors.length === 0;

  }
}

export class LoginViewModel {
  public isCheckLoggedinDone: boolean;
  public isLoading: boolean;
  public userName: string;
  public password: string;
  public isRememberMe: boolean;
  public errors: ValidationError[];
}
